
import React from 'react'
import Container from '../components/Container'
import { ScrollFadeIn, ScrollFadeInStagger } from '../../../components/ScrollFadeIn'
import { FaPeopleCarryBox } from 'react-icons/fa6'
import { MdOutlineSupportAgent } from 'react-icons/md'
import GetStartedButton from '../components/GetStartedButton'
import { TbMapHeart } from 'react-icons/tb'

const items = [
    {
        name_line_1: 'Work with a',
        name_line_2: 'Trusted Partner',
        description: 'With Abundo, you have a dedicated advisor and a personalized one-on-one relationship. This trusted advisor is readily available for consultations through virtual meetings and emails. All of our advisors are prepared to give you expert, customized guidance designed to meet your specific needs.',
        icon: FaPeopleCarryBox,
    },
    {
        name_line_1: 'Build a Plan ',
        name_line_2: 'You Love',
        description: 'Together we\'ll identify your goals and what you\'re hoping to accomplish financially. We\'ll create a detailed action plan with easy to follow steps to help improve your chances of success. We will help simplify your finances to reduce uncertainty and stress which will make planning for your future fun!',
        icon: TbMapHeart,
    },
    {
        name_line_1: 'Always Feel',
        name_line_2: 'Supported',
        description: 'Be a part of the Abundo family, where our team is here to guide you through all of life\'s uncertainties. We understand life comes with lots of ups and downs. Whether it\'s job changes, market uncertainty, or unexpected expenses, we are always here to provide direction so you can make the best decisions.',
        icon: MdOutlineSupportAgent,
    },
]

const GetStartedNow = () => {
    return (
        <section>
            <Container bgColor='bg-gradient-to-bl from-sky-blue-200 via-primary-300 to-primary-500'>
                <ScrollFadeIn>
                    <h2 className="text-white text-center heading-2 mx-auto max-w-4xl">
                        Everyone deserves high-quality advice, transparent pricing, and low-cost investing.
                    </h2>
                </ScrollFadeIn>
                <ScrollFadeInStagger className="grid lg:grid-cols-3 gap-16 mx-auto justify-items-center mt-10 sm:mt-16">
                    {items.map((item, index) => (
                     
                        <ScrollFadeIn key={index} className='bg-white shadow-lg px-10 py-6 rounded-lg flex flex-col items-center space-y-4 w-full max-w-md'>
                            
                            <div className="flex flex-col items-center">
                                <div className="bg-primary-800 h-12 w-12 text-white rounded-full flex justify-center items-center text-2xl font-lato">
                                    <item.icon className='text-white h-7 w-7' />
                                </div>
                                <div className="hidden sm:block text-primary-800">
                                    <h3 className="mt-3 heading-2 text-center max-w-[300px]">{item.name_line_1}</h3>
                                    <h3 className="heading-2 text-center max-w-[300px] -mt-1">{item.name_line_2}</h3>
                                </div>
                                <div className="sm:hidden text-primary-800">
                                    <h3 className="mt-3 heading-2 text-center max-w-[300px]">{item.name_line_1} {item.name_line_2}</h3>
                                </div>
                            </div>
                            <div className="bg-gradient-to-br from-sky-blue-200 via-primary-300 to-primary-500 h-1 w-full" />
                            <p className="body-1 text-center text-gray-600">
                                {item.description}
                            </p>
                        </ScrollFadeIn>
                    ))}
                </ScrollFadeInStagger>
                <ScrollFadeIn className="mt-16 flex justify-center">
                    <GetStartedButton id='home-page-cta-1' />
                </ScrollFadeIn>
            </Container>
        </section>
    )
}

export default GetStartedNow
